"use strict";

const IncidentEnforcementController = require("./incidentEnforcementController");
const BaseEnforcementHistory = require("../../enforcement/baseEnforcementHistory");

const EnforcementHistory = function () {
  const base = BaseEnforcementHistory(IncidentEnforcementController, {});

  return {
    ...base,
  };
};

module.exports = EnforcementHistory();
